import { TableRowSelection } from 'antd/lib/table/interface';
import { flatten } from 'flat';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { DocumentModel, DOCUMENT_PUBLICATION_STATUS } from 'api/documents/documents.model';
import Table from 'components/Table';
import { CertificateDetailsModel } from 'models/certificate.model';

import { FilterableQueryResultType } from '../../../types';
import useCertificatesTableConfig from '../useCertificatesTableConfig';

type CertificatesListType = FilterableQueryResultType<DocumentModel<CertificateDetailsModel>> & {
  rowSelection?: TableRowSelection<DocumentModel<CertificateDetailsModel>>;
  selectedTab?: string;
};

const CertificatesList = ({ data, rowSelection, selectedTab }: CertificatesListType) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const isInteractable = !rowSelection;

  const certificatesTableConfig = useCertificatesTableConfig(isInteractable);

  return (
    <Table
      numberOfRecords={data?.count}
      data={data?.rows || []}
      pagination
      config={certificatesTableConfig}
      rowSelection={rowSelection}
      onRowClick={({ documentBlockchainAddress, documentPublicationStatus }) =>
        !rowSelection &&
        documentPublicationStatus === DOCUMENT_PUBLICATION_STATUS.PUBLISHING_OK &&
        navigate(`/home/certificates/${documentBlockchainAddress}`, {
          state: {
            searchParams: flatten({ ...Object.fromEntries([...searchParams]) }),
            selectedTab,
          },
        })
      }
      rowKey={(certificate) => certificate.jobId}
    />
  );
};

export default CertificatesList;
